<template>
    <div class="container-fluid p-consultations">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">{{ $locale.consultation_host }}一覧</div>

                    <div class="card-body p-consultations__content pt-2">
                        <div class="d-block d-md-flex justify-content-between mb-1">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select v-model="medicalCourseId"
                                                @change="fetchConsultations"
                                                style="min-width: 100px;"
                                                class="form-control">
                                            <option :value="null">{{ $locale.consultation_host }}科を選択してください</option>
                                            <option v-for="course in medicalCourses"
                                                    :value="course.id">
                                                {{ course.name }}
                                            </option>
                                            <option value="all">すべての{{ $locale.consultation_host }}科</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select v-model="selectedDoctorId"
                                                @change="fetchConsultations"
                                                style="min-width: 100px;"
                                                class="form-control">
                                            <option :value="null">医師を選択してください</option>
                                            <option v-for="doctor in doctors"
                                                    :value="doctor.id">
                                                {{ doctor.full_name }}
                                            </option>
                                            <option value="all">すべての医師</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select v-model="user_category_id"
                                                @change="fetchConsultations"
                                                id="user_category_id"
                                                style="min-width: 100px;"
                                                class="form-control">
                                            <option :value="null">{{ $locale.patient }}区分を選択してください</option>
                                            <option v-for="user_category in user_categories" :value="user_category.id">
                                                {{ user_category.name }}
                                            </option>
                                            <option value="all">すべての{{ $locale.patient }}区分</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="status"
                                            @change="fetchConsultations"
                                            id="status"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">ステータスを選択してください</option>
                                            <option
                                                v-for="status in consultationSearchStatuses"
                                                :value="searchStatusValue(status)">
                                                {{ searchStatusText(status) }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="freeword"
                                            @blur="fetchConsultations"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード"
                                            style="min-width: 100px;">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text"
                                                @click="fetchConsultations">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <input
                                            v-model="user_id"
                                            @blur="fetchConsultations"
                                            type="text"
                                            class="form-control"
                                            :placeholder="`${this.$locale.patient}番号`"
                                            style="min-width: 100px;">
                                        <div class="input-group-append">
                                            <div
                                                class="input-group-text"
                                                @click="fetchConsultations">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <span class="small">{{ $locale.consultation_host }}日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="c-freeword input-group input-group-sm">
                                            <input type="date" class="form-control"
                                                   aria-label="Recipient's username"
                                                   aria-describedby="basic-addon2"
                                                   @change="fetchConsultations"
                                                   style="min-width: 100px;"
                                                   v-model="start_time">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="c-freeword input-group input-group-sm">
                                            <input type="date" class="form-control"
                                                   aria-label="Recipient's username"
                                                   aria-describedby="basic-addon2"
                                                   @change="fetchConsultations"
                                                   style="min-width: 100px;"
                                                   v-model="end_time">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :class="{ 'u-loader u-loader--p5' : ! consultations }">
                            <div v-if="consultations" class="mt-3">
                                <div class="d-flex flex-wrap mb-1">
                                    <div class="reservedNotice small mr-2">
                                        <div></div>
                                        <div>&nbsp;:&nbsp;医師による予約</div>
                                    </div>
                                    <div class="reservedNotice reservedNoticeMatching small mr-2">
                                        <div></div>
                                        <div>&nbsp;:&nbsp;マッチング予約</div>
                                    </div>
                                    <div class="d-flex align-items-center small mr-2">
                                        <div class="reservedLabel">再</div>
                                        <div>&nbsp;:&nbsp;再{{ $locale.consultation_host }}</div>
                                    </div>
                                    <div class="d-flex align-items-center small mr-2">
                                        <div class="reservedLabel reservedLabelDraftCancel">ド</div>
                                        <div>&nbsp;:&nbsp;ドラフト経由（前回キャンセル）</div>
                                    </div>
                                    <div class="d-flex align-items-center small">
                                        <div class="reservedLabel reservedLabelDraftDoctor">ド</div>
                                        <div>&nbsp;:&nbsp;ドラフト経由（医師の依頼）</div>
                                    </div>
                                </div>

                                <b-table
                                    striped
                                    hover
                                    :items="consultations"
                                    :fields="fields"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    @sort-changed="fetchConsultations"
                                    :responsive="true"
                                    class="table-bordered m-table">
                                    <template v-slot:cell(id)="data">
                                        <div :class="{
                                            'reservedByDoctor' : Number(data.item.flg_reserved_by_doctor) === 1,
                                            'reservedByMatching' : Number(data.item.is_matching_reserved) === 1,
                                        }">
                                            {{ data.item.id }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(start_time)="data">
                                        <div>
                                            <span>{{ helper.dateForHuman( data.item.start_time,timezone, { simpleYear: true } ) }}</span>
                                            <span class="small font-weight-bold"
                                                  :class="helper.dayForHumanCSS( data.item.start_time ,timezone)">
                                                {{ helper.dayForHuman( data.item.start_time, timezone, { bracket: true } ) }}
                                            </span>
                                        </div>
                                        <div>
                                            <span>{{ helper.timeForHuman( data.item, timezone) }}</span>
                                            <span>{{ helper.consultationOrder( data.item, consultations ) }}</span>
                                        </div>
                                        <timezone-box
                                            v-if="data.item.user && data.item.user.timezone !== 'Asia/Tokyo'"
                                            :consultation="data.item"
                                            :timezone="data.item.user.timezone"
                                            as-user>
                                        </timezone-box>
                                        <timezone-box
                                            v-if="data.item.doctor && data.item.doctor.timezone !== 'Asia/Tokyo'"
                                            :consultation="data.item"
                                            :timezone="data.item.doctor.timezone"
                                            as-doctor>
                                        </timezone-box>
                                    </template>

                                    <template v-slot:cell(medical_courses.name)="data">
                                        <template v-if="data.item.doctor_menu">
                                            <div style="line-height:1.3; margin-top:2px;">
                                                {{ data.item.medical_course.name }}
                                            </div>
                                            <div
                                                v-if="data.item.doctor_menu.is_health_package"
                                                class="doctorMenuHealthPackageIcon">
                                                <img src="/images/common/label_health_package1.png">
                                            </div>
                                            <a href="#" @click="showModalDoctorMenu(data.item.doctor_menu_id, data.item)">
                                                {{ data.item.doctor_menu.title }}
                                            </a>
                                            <div
                                                v-if="data.item.is_repeat_reserved"
                                                class="reservedLabel">
                                                再
                                            </div>
                                            <div
                                                v-if="data.item.reserved_as === 'DRAFT_CANCEL' || data.item.reserved_as === 'DRAFT_DOCTOR'"
                                                :class="{
                                                    'reservedLabelDraftCancel' : data.item.reserved_as === 'DRAFT_CANCEL',
                                                    'reservedLabelDraftDoctor' : data.item.reserved_as === 'DRAFT_DOCTOR',
                                                }"
                                                class="reservedLabel">
                                                ド
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div>{{ data.item.medical_course.name }}</div>
                                        </template>
                                    </template>

                                    <template v-slot:cell(doctors.full_name_kana)="data">
                                        <template v-if="data.item.doctor">
                                            <a href="#" @click="showModalDoctorProfile(data.item.doctor_id, $event)">
                                                {{ data.item.doctor.full_name }}
                                            </a>
                                            <div class="small">{{ data.item.doctor.full_name_kana }}</div>
                                        </template>
                                        <template v-else-if="data.item.doctor_id === null">
                                            <div class="text-muted">未定</div>
                                        </template>
                                        <template v-else>
                                            <span class="text-muted">退会済の医師</span>
                                        </template>
                                    </template>

                                    <template v-slot:cell(join_users.full_name_kana)="data">
                                        <template v-if="data.item.user">
                                            <a href="#" @click="showModalUserProfile(data.item,$event)">
                                                {{ data.item.user.full_name }}&nbsp;<span class="small">({{data.item.user.age}})</span>
                                            </a>
                                            <div class="small">{{ data.item.user.full_name_kana }}</div>
                                            <div
                                                v-if="data.item.user.groups.length > 0"
                                                class="small mt-1">
                                                <a :href="`/admin/companies/${data.item.user.groups[0].id}`">
                                                    <b-icon-building/>
                                                    <span>{{ data.item.user.groups[0].name }}</span>
                                                </a>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="text-muted">退会済の{{ $locale.patient }}</span>
                                        </template>
                                    </template>

                                    <template v-slot:cell(join_users.user_category_id)="data">
                                        <template v-if="data.item.user">
                                            <div v-for="user_category in user_categories">
                                                <div v-if="user_category.id === data.item.user.user_category_id">
                                                    {{ user_category.name }}
                                                </div>
                                            </div>
                                        </template>
                                    </template>

                                    <template v-slot:cell(plan_id)="data">
                                        <div>{{ data.item.plan.name }}</div>
                                    </template>

                                    <template v-slot:cell(status)="data">
                                        <div
                                            class="c-indicator"
                                            :class="detectStatusCSS( data.item )">
                                            <span>{{ detectStatusName(data.item) }}</span>
                                            <span v-if="isDoctorConfirmed(data.item)" class="text-success u-palt">（確認済）</span>
                                            <span>/</span>
                                            <span>{{ detectStatusNameMedicalRecord(data.item) }}</span>
                                        </div>
                                        <div class="d-flex mt-1">
                                            <div
                                                v-show="data.item.messages_count > 0"
                                                class="c-counter-badge mr-2">
                                                <b-icon-chat-dots-fill></b-icon-chat-dots-fill>
                                            </div>
                                            <div
                                                v-show="data.item.images_count > 0"
                                                class="c-counter-badge mr-2">
                                                <img src="/images/common/icon_camera2_bk.svg" style="width: 14px; position: relative; top: -1px;">
                                                <span class="c-counter-badge__item">{{ data.item.images_count }}</span>
                                            </div>
                                            <div
                                                v-show="data.item.attached_images_count > 0"
                                                class="c-counter-badge">
                                                <b-icon-images></b-icon-images>
                                                <span class="c-counter-badge__item">{{ data.item.attached_images_count }}</span>
                                            </div>
                                        </div>
                                        <div
                                            v-if="data.item.flg_cancel || isAbsence(data.item)"
                                            class="cancelReasonWrapper"
                                            :class="{ 'cancelReasonWrapperAbsence' : isAbsence(data.item) }">
                                            <div class="cancelReasonHeading">
                                                <div>{{ cancelReasonHeadingText(data.item) }}</div>
                                            </div>
                                            <div class="cancelReasonContent">
                                                <div class="cancelReasonDatetime d-flex justify-content-between">
                                                    <div>
                                                        {{ `キャンセル日時${helper.dateTimeForHuman(isAbsence(data.item) ? data.item.finished_at : data.item.canceled_at, timezone)}` }}
                                                    </div>
                                                    <img
                                                        src="/images/common/icon-magnifying-glass.svg"
                                                        @click="onClickCancelReason(data.item)">
                                                </div>
                                                <div
                                                    v-if="isRequiredCancelReason(data.item)"
                                                    class="cancelReason text-danger font-weight-bold">
                                                    ※キャンセル事由：未回答
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(medical_records.published_at)="data">
                                        <div
                                            v-if="data.item.medical_record && data.item.medical_record.published_at"
                                            class="u-palt">
                                            <span>
                                                {{ helper.dateForHuman(data.item.medical_record.published_at, timezone, { simpleYear: true }) }}
                                            </span>
                                            <span
                                                class="small font-weight-bold"
                                                :class="helper.dayForHumanCSS(data.item.medical_record.published_at, timezone)">
                                                {{ helper.dayForHuman(data.item.medical_record.published_at, timezone, { bracket: true }) }}
                                            </span>
                                            <span>{{ helper.timeForHuman(data.item.medical_record.published_at, timezone) }}</span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(invoices.status)="data">
                                        <div
                                            v-if="data.item.doctor_menu && data.item.doctor_menu.is_health_package"
                                            class="text-muted">
                                            -
                                        </div>
                                        <div
                                            v-else-if="data.item.is_force_paid"
                                            class="text-muted">
                                            支払済
                                        </div>
                                        <div v-else-if="data.item.invoice">
                                            <a
                                                v-if="isViewableInvoice(data.item.invoice)"
                                                :href="data.item.invoice.dashboard_url"
                                                target="_blank">
                                                {{ detectInvoiceStatusName(data.item.invoice) }}
                                            </a>
                                            <span v-else>
                                                {{ detectInvoiceStatusName(data.item.invoice) }}
                                            </span>
                                            <div class="small text-muted">請求ID:&nbsp;#{{ data.item.invoice.id }}</div>
                                            <div
                                                v-if="data.item.payment_method && !canSkipPayment(data.item)"
                                                class="small text-muted">
                                                {{ data.item.payment_method.name }}
                                            </div>
                                        </div>
                                        <div
                                            v-else
                                            class="text-muted">
                                            未請求
                                        </div>

                                        <div v-if="!data.item.is_force_paid">
                                            <b-button
                                                v-if="payableAsManual(data.item)"
                                                type="button"
                                                class="btn btn-sm mt-1"
                                                variant="yokumiru-red"
                                                @click="openStoreInvoiceModal(data.item)">請求
                                            </b-button>
                                            <b-button
                                                v-if="cancelable(data.item)"
                                                type="button"
                                                class="btn btn-sm mt-1"
                                                variant="yokumiru-gray"
                                                target="_blank"
                                                @click="openCancelInvoiceModal(data.item.invoice)">
                                                キャンセル
                                            </b-button>
                                        </div>
                                    </template>

                                    <template v-slot:cell(consultation_detail)="data">
                                        <b-button
                                            type="button"
                                            class="btn btn-info btn-sm"
                                            variant="yokumiru-dark-green" data-toggle=""
                                            data-target=""
                                            :href="`/admin/consultations/${data.item.id}`">
                                            記録
                                        </b-button>
                                        <b-button
                                            v-if="data.item.doctor_id && consultationStatus.canCancelAll.includes(data.item.status)"
                                            type="button"
                                            variant="yokumiru-blue"
                                            class="btn btn-sm ml-1"
                                            @click="onClickChangeBtn(data.item, $event)">
                                            予約変更
                                        </b-button>
                                        <b-button
                                            v-if="data.item.doctor_id === null && !consultationStatus.cancelAll.includes(data.item.status)"
                                            type="button"
                                            variant="yokumiru-red"
                                            class="btn btn-sm ml-1"
                                            @click="onClickMatchingBtn(data.item, $event)">
                                            マッチングする
                                        </b-button>
                                    </template>
                                </b-table>

                                <div class="d-flex flex-wrap justify-content-between align-items-center">
                                    <b-pagination
                                          :total-rows="paginationConf.totalRows"
                                          :per-page="paginationConf.perPage"
                                          v-model="paginationConf.currentPage"
                                          @change="fetchConsultations">
                                    </b-pagination>

                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="mr-3 mb-3">
                                            <span class="small">{{ dispPaginationDetail }}</span>
                                        </div>
                                        <div class="mb-3">
                                            <b-button
                                                variant="yokumiru-orange"
                                                @click="downloadCSV"
                                                :disabled="inProgress">
                                                CSVダウンロード
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <admin-user-profile-modal :timezone="timezone"/>
        <admin-doctor-profile-modal/>
        <manual-store-invoice-modal/>
        <auth-confirm-invoice-modal/>
        <cancel-invoice-modal/>
        <doctor-menu-modal user-type="admin"/>

        <admin-alternative-doctor-menu-select-modal/>
        <admin-alternative-doctor-menu-schedule-modal/>
        <admin-alternative-doctor-menu-confirm-modal/>

        <admin-matching-doctor-select-modal/>
        <admin-matching-doctor-confirm-modal/>
        <admin-matching-doctor-schedule-modal/>
        <admin-matching-interview-answers-modal/>

        <consultation-cancel-info-modal/>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import YokumiruHelper from '../../YokumiruHelper'
    import { sprintf } from 'sprintf-js'
    import { saveAs } from 'file-saver'

    export default {
        name: "Consultations",

        props: {
            timezone:{
                type: String,
                default: null,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                consultations: null,
                medicalCourses: null,
                medicalCourseId: null,
                doctors: null,
                selectedDoctorId: null,
                user_category_id: null,
                status: null,
                start_time: null,
                end_time: null,
                freeword: '',
                user_id: null,
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                    from: 0,
                    to: 0,
                },
                user_categories: [],
                sortBy: 'start_time',
                sortDesc: true,
                consultationStatus: constants.consultations,
                invoiceStatus: constants.invoices,
                fields: [
                    {
                        key: 'id',
                        label: '#',
                        sortable: true,
                    },
                    {
                        key: 'start_time',
                        label: `${this.$locale.consultation_host}日時`,
                        sortable: true,
                    },
                    {
                        key: 'medical_courses.name',
                        label: `${this.$locale.consultation_host}科・メニュー`,
                        sortable: true,
                    },
                    {
                        key: 'doctors.full_name_kana',
                        label: '医師',
                        sortable: true,
                    },
                    {
                        key: 'join_users.full_name_kana',
                        label: `${this.$locale.patient} (年齢)`,
                        sortable: true,
                    },
                    {
                        'key': 'join_users.user_category_id',
                        'label': `${this.$locale.patient}区分`,
                        sortable: true,
                    },
                    {
                        'key': 'plan_id',
                        'label': 'サービスモデル',
                        sortable: true,
                    },
                    {
                        'key': 'join_users.user_code',
                        'label': '所属コード',
                        sortable: true,
                    },
                    {
                        key: 'status',
                        label: 'ステータス',
                        sortable: true,
                    },
                    {
                        key: 'medical_records.published_at',
                        label: '記録公開日時',
                        sortable: true,
                    },
                ],
            };
        },

        created: function () {
            this.initQuery()
            this.fetchConsultations()
            this.fetchMedicalCourses()
            this.fetchDoctors()
            this.fetchUserCategories()

            if (this.$store.state.configs.payment == 1) {
                this.fields.push({
                    key: 'invoices.status',
                    label: '請求',
                    sortable: true,
                })
            }
            this.fields.push({
                key: 'consultation_detail',
                label: '',
                class: 'text-center',
                sortable: false,
            })

            bus.$on('invoice-attempted', this.updateInvoiceAttempted)
            bus.$on('invoice-canceled', this.updateInvoiceCanceled)
            bus.$on('admin-doctor-matching-completed', this.fetchConsultations)
            bus.$on('admin-doctor-menu-change-completed', this.fetchConsultations)
        },

        beforeDestroy: function () {
            bus.$off('invoice-attempted')
            bus.$off('invoice-canceled')
            bus.$off('admin-doctor-matching-completed')
            bus.$off('admin-doctor-menu-change-completed')
        },

        methods: {
            /**
             * 検索条件ステータス値
             * @param status
             * @return {*}
             */
            searchStatusValue: function (status) {
                return status.value
            },

            /**
             * 検索条件ステータス表記
             * @param status
             * @return {*}
             */
            searchStatusText: function (status) {
                let text = status.text

                if (this.$locale.type === 'consul') {
                    text = text.replace('診療', '相談')
                    text = text.replace('患者', '会員')
                }
                return text
            },

            /**
             * 事前ログイン確認済みラベルの表示判定
             * @see https://github.com/sewii/Yokumiru/issues/579
             *
             * @param {object} consultation
             * @return {boolean}
             */
            isDoctorConfirmed: function (consultation) {
                if (!this.$store.state.configs.consultation_cancel_doctor_login) {
                    return false
                }
                if (!this.consultationStatus.canCancelAll.includes(consultation.status)) {
                    return false
                }
                if (!consultation.doctor || !consultation.doctor.active_at) {
                    return false
                }

                const reservedAt = moment(consultation.reserved_at)
                const activeAt = moment(consultation.doctor.active_at)

                return activeAt.isSameOrAfter(reservedAt)
            },

            /**
             * 無料メニューかどうか
             *
             * @param {object} consultation
             * @return {boolean}
             */
            canSkipPayment: function (consultation) {
                return this.$locale.type === 'consul' && consultation.estimated_total <= 0
            },

            /**
             * 請求完了後のデータ更新
             *
             * @param {object} data
             */
            updateInvoiceAttempted: function (data) {
                const c = this.consultations.find(consultation => consultation.id === data.invoice.consultation_id)

                if (c) {
                    c.invoice = data.invoice

                    /**
                     * success = 定期課金／支払い再試行時のレスポンス（クレカ決済確定）
                     * attempt_type = 相談料の請求時のレスポンス（クレカ／オーソリのみ／請求書送付）
                     */

                    if (data.success === true) {
                        c.invoice.status = constants.invoices.paid
                    }
                    else if (data.success === false) {
                        c.invoice.status = constants.invoices.failed
                    }
                    else if (data.attempt_type === 'pay') {
                        c.invoice.status = data.success ? constants.invoices.paid : constants.invoices.failed
                    }
                    else if (data.attempt_type === 'authorize') {
                        c.invoice.status = data.success ? constants.invoices.authorized : constants.invoices.authorizeFailed
                    }
                    else if (data.attempt_type === 'send_invoice') {
                        c.invoice.status = constants.invoices.authorized
                        c.invoice.send_at = moment().format('YYYY-MM-DD HH:mm:ss')
                    }
                }
            },

            /**
             * キャンセル完了後のデータ更新
             *
             * @param {object} invoice
             */
            updateInvoiceCanceled: function (invoice) {
                const c = this.consultations.find(consultation => consultation.invoice && consultation.invoice.id === invoice.id)

                if (c) {
                    c.invoice.status = constants.invoices.canceled
                    c.invoice.stripe_status = 'void'
                    c.invoice.canceled_at = invoice.canceled_at
                }
            },

            /**
             * 請求モーダル表示
             */
            openStoreInvoiceModal: function(consultation) {
                if (consultation.invoice) {
                    bus.$emit('open-modal-auth-confirm-invoice', consultation, 'admin')
                }
                else {
                    bus.$emit('open-modal-store-invoice', consultation, 'admin')
                }
            },

            /**
             * 請求キャンセルモーダルの表示
             *
             * @param {object} invoice
             */
            openCancelInvoiceModal: function (invoice) {
                bus.$emit('open-modal-cancel-invoice', invoice)
            },

            /**
             * 手動請求可能判定
             *
             * @param {object} consultation
             * @return {boolean}
             */
            payableAsManual: function (consultation) {
                const baseCondition = this.$store.state.configs.payment == 1
                    && this.$store.state.configs.payment_consultation_auto_charge != 1
                    && constants.consultations.canPublishAll.includes(consultation.status)

                const recordCondition = this.$store.state.configs.subscription != 1
                    || (consultation.medical_record && consultation.medical_record.published_at)

                // 請求書が既に発行されている場合
                if (consultation.invoice) {
                    return baseCondition
                        && recordCondition
                        && consultation.invoice.status === this.invoiceStatus.authorized
                        && consultation.invoice.send_at === null
                }
                return baseCondition && recordCondition
            },

            /**
             * 請求キャンセル可能状態判定
             *
             * @param {object} consultation
             */
            cancelable: function (consultation) {
                const baseCondition = this.$store.state.configs.payment == 1
                    && this.$store.state.configs.payment_consultation_auto_charge == 1
                    && consultation.medical_record
                    && consultation.medical_record.published_at
                    && consultation.invoice
                    && consultation.invoice.status === this.invoiceStatus.authorized

                let autoChargeCondition = false

                if (baseCondition) {
                    const publishedAt = consultation.medical_record.published_at
                    const autoChargeAt = moment(publishedAt).add(this.$store.state.configs.payment_consultation_auto_charge_after_min, 'minutes')
                    autoChargeCondition = moment().isBefore(autoChargeAt)
                }

                return baseCondition && autoChargeCondition
            },

            /**
             * 医師一覧取得
             */
            fetchDoctors: function () {
                axios.get(`${constants.admin.doctors.endpoint.all}`)
                    .then( ({data}) => {
                        this.doctors = data;
                    } );
            },

            /**
             * QueryString初期化
             * バリデーションはLaravel側を参照
             *
             * @see App\Http\Requests\Doctor\ConsultationIndexRequest::rules()
             */
            initQuery: function() {
                this.medicalCourseId = Number( this.$route.query.medical_course_id ) || null;
                this.freeword = this.$route.query.freeword || '';
                this.user_id = this.$route.query.user_id || '';
                this.sortBy = this.$route.query.sort || 'start_time';
                this.sortDesc = this.$route.query.desc !== 'false';
                this.paginationConf.currentPage = Number( this.$route.query.page ) || 1;
                this.selectedDoctorId = Number( this.$route.query.selectedDoctorId ) || null;
                this.user_category_id = Number( this.$route.query.user_category_id ) || null;
                this.status = this.$route.query.status || null;
                this.start_time = this.$route.query.start_time || null;
                this.end_time = this.$route.query.end_time || null;
            },

            /**
             * QueryString更新
             *
             * @param {object} ctx
             */
            updateQuery: function ( ctx ) {
                if ( ctx !== null && ctx.hasOwnProperty( 'sortBy' ) ) {
                    this.sortBy = ctx.sortBy;
                    this.sortDesc = ctx.sortDesc;
                }

                this.$router.replace( {
                    path: this.$route.path,
                    query: {
                        medical_course_id: Number.isInteger(this.medicalCourseId) ? this.medicalCourseId : null,
                        freeword: this.freeword,
                        user_id: this.user_id,
                        sort: this.sortBy,
                        desc: this.sortDesc,
                        page: this.paginationConf.currentPage,
                        selectedDoctorId: Number.isInteger(this.selectedDoctorId) ? this.selectedDoctorId : null,
                        user_category_id: Number.isInteger(this.user_category_id) ? this.user_category_id : null,
                        status: this.status,
                        start_time: this.start_time,
                        end_time: this.end_time,
                    },
                } ).catch(error => {});
            },

            /**
             * 相談一覧
             * @param {number|object} param
             */
            fetchConsultations: function (param = null) {
                this.consultations = null

                if (Number.isInteger(param) && param > 0) {
                    this.paginationConf.currentPage = param
                }

                this.updateQuery(param)
                const endpoint = constants.admin.consultations.endpoint.base

                axios.get(`${endpoint}${this.buildQuery()}`)
                    .then(({data}) => {
                        this.consultations = data.data
                        this.paginationConf.perPage = data.meta.per_page
                        this.paginationConf.totalRows = data.meta.total
                        this.paginationConf.from = data.meta.from
                        this.paginationConf.to = data.meta.to
                    })
            },

            /**
             * 診療科一覧
             */
            fetchMedicalCourses: function () {
                axios.get(`${constants.admin.medical_courses.endpoint.base}?show=1`)
                    .then( ({data}) => {
                        this.medicalCourses = data;
                    } );
            },

            /**
             * 患者詳細モーダル表示
             */
            showModalUserProfile: function (consultation,event) {
                event.preventDefault();
                bus.$emit(
                    'open-modal-admin-user-profile',
                    consultation.user_id,
                    consultation.id
                );
            },

            /**
             * 医師詳細モーダル表示
             *
             * @param {number} doctorId
             * @param {object} e
             */
            showModalDoctorProfile: function (doctorId, e) {
                e.preventDefault()
                bus.$emit('open-modal-admin-doctor-profile', doctorId)
            },

            /**
             * ステータス表記（相談記録）
             *
             * @param {object} consultation
             * @return {string}
             */
            detectStatusNameMedicalRecord: function (consultation) {
                if (consultation.medical_record && consultation.medical_record.published_at) {
                    return '記録公開済'
                }
                return '記録未公開'
            },

            /**
             * ステータス表記
             *
             * @param {object} consultation
             * @return {string}
             */
            detectStatusName: function (consultation) {
                let result = this.consultationStatus.all.find(status => {
                    return status.value === consultation.status
                })

                if (this.$locale.type === 'consul') {
                    result.text = result.text.replace('診療', '相談')
                    result.text = result.text.replace('患者', '会員')
                }

                // キャンセル
                if (consultation.flg_cancel == 1) {
                    if (constants.consultations.cancelAll.includes(result.value)) {
                        return result.text
                    }
                    if (consultation.flg_cancel_by_doctor == 1) {
                        return 'キャンセル（医師）'
                    }
                    return this.$locale.type === 'consul' ? 'キャンセル（会員）' : 'キャンセル（患者）'
                }

                // その他
                return result.text
            },

            /**
             * ステータス表記
             *
             * @param {object} consultation
             * @return {string}
             */
            detectStatusCSS: function (consultation) {
                const result = this.consultationStatus.all.find(status => {
                    return status.value === consultation.status
                })

                // 診療終了
                if (result.value === this.consultationStatus.finished) {
                    if (!consultation.medical_record ||
                        !consultation.medical_record.body ||
                        consultation.medical_record.body.length < 1) {
                        return 'c-indicator--yellow'
                    }
                }
                return result.css
            },

            /**
             * 会員種別の取得
             */
            fetchUserCategories: function () {
                axios.get(`${constants.admin.users.endpoint.user_categories}?show=1`)
                    .then(({data}) => {
                        this.user_categories = data
                    }).catch(function (error) {
                        console.log(error)
                    });
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function(paginate = true) {
                let query = '?'

                if (paginate) {
                    query += `page=${this.paginationConf.currentPage}`
                    query += `&sort=${this.sortBy}`
                    query += `&desc=${this.sortDesc}`
                }
                else {
                    query += `sort=${this.sortBy}`
                    query += `&desc=${this.sortDesc}`
                }

                if (this.medicalCourseId && Number(this.medicalCourseId) > 0) {
                    query += `&medical_course_id=${this.medicalCourseId}`
                }
                if (this.freeword.length > 0) {
                    query += `&freeword=${this.freeword}`;
                }
                if (this.user_id) {
                    query += `&user_id=${this.user_id}`;
                }
                if (this.selectedDoctorId && Number(this.selectedDoctorId) > 0) {
                    query += `&selectedDoctorId=${this.selectedDoctorId}`
                }
                if (this.user_category_id && Number(this.user_category_id) > 0) {
                    query += `&user_category_id=${this.user_category_id}`
                }
                if (this.status) {
                    query += `&status=${this.status}`
                }
                if (this.start_time) {
                    query += `&start_time=${ moment(this.start_time).set({'hour' : 0 , 'minute' : 0 , 'second' : 0 }).format( 'YYYY-MM-DD HH:mm:ss' ) }`;
                }
                if (this.end_time) {
                    query += `&end_time=${ moment(this.end_time).set({'hour' : 23 , 'minute' : 59 , 'second' : 59 }).format( 'YYYY-MM-DD HH:mm:ss' ) }`;
                }

                return query
            },

            /**
             * 請求ステータス表記
             *
             * @param {object} invoice
             * @return {string}
             */
            detectInvoiceStatusName: function (invoice) {
                let result = this.invoiceStatus.all.find(status => {
                    return status.value === invoice.status
                })

                if (result && this.$store.state.configs.subscription != 1) {
                    if (result.value === constants.invoices.authorized
                        && invoice.send_at
                        && invoice.payment_method_id !== constants.payment_methods.credit) {
                        return '請求済'
                    }
                }

                return result ? result.text : ''
            },

            /**
             * Stripeダッシュボードで閲覧可能な請求書か判定
             *
             * @param {object} invoice
             * @return {boolean}
             */
            isViewableInvoice: function (invoice) {
                return invoice.status !== this.invoiceStatus.authorizeFailed
            },

            /**
             * 医師メニュー詳細モーダル表示
             *
             * @param {number} doctorMenuId
             * @param {object} consultation
             */
            showModalDoctorMenu: function (doctorMenuId, consultation) {
                bus.$emit('open-modal-doctor-menu', doctorMenuId, consultation)
            },

            /**
             * CSVダウンロード
             */
            downloadCSV: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.admin.consultations.endpoint.base}/export${this.buildQuery(false)}`
                const options = { responseType : 'blob' }

                await axios.get(endpoint, options)
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: response.data.type,
                        })
                        saveAs(
                            blob,
                            sprintf(
                                '%s一覧_%s.csv',
                                this.$locale.consultation_host,
                                moment().format('YYYYMMDD')
                            )
                        )
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },

            /**
             * 予約変更ボタン押下時
             * @param {object} consultation
             * @param {object} e
             */
            onClickChangeBtn: function (consultation, e) {
                e.preventDefault()
                bus.$emit('open-modal-admin-alternative-doctor-menu-select', consultation)
            },

            /**
             * マッチングするボタン押下時
             * @param {object} consultation
             * @param {object} e
             */
            onClickMatchingBtn: function (consultation, e) {
                e.preventDefault()
                bus.$emit('open-modal-admin-matching-doctor-select', consultation)
            },

            /**
             * 未入室終了かどうか
             * @param {object} consultation
             * @return {boolean}
             */
            isAbsence: function (consultation) {
                return this.consultationStatus.absenceAll.includes(consultation.status)
            },

            /**
             * キャンセル事由の見出しテキスト
             * @param {object} consultation
             */
            cancelReasonHeadingText: function (consultation) {
                const status = consultation.status
                const patient = this.$locale.patient
                const consultationHost = this.$locale.consultation_host

                // 会員起因
                if (status === this.consultationStatus.canceledAuthUser) {
                    return `${patient}による${consultationHost}24時間前以降のキャンセル`
                }
                else if (status === this.consultationStatus.absenceUser) {
                    return `${patient}による未入室終了`
                }
                else if (status === this.consultationStatus.canceledUser) {
                    return `${patient}によるキャンセル`
                }

                // 医師起因
                if (consultation.cancel_category === constants.cancelCategory.doctorLogin) {
                    return `医師の予約未確認による自動キャンセル`
                }
                else if (status === this.consultationStatus.canceledAuthDoctor) {
                    return `医師による${consultationHost}24時間前以降のキャンセル`
                }
                else if (status === this.consultationStatus.absenceDoctor) {
                    return `医師による未入室終了`
                }
                else if (status === this.consultationStatus.canceledDoctor) {
                    return '医師によるキャンセル'
                }
                return ''
            },

            /**
             * キャンセル事由の未回答判定
             * @param {object} consultation
             */
            isRequiredCancelReason: function (consultation) {
                // すでにキャンセル事由が記入済み
                if (consultation.cancel_reason !== null && consultation.cancel_reason !== '') {
                    return false
                }
                return consultation.cancel_category === constants.cancelCategory.doctorLogin
                    || consultation.status === this.consultationStatus.canceledAuthDoctor
                    || consultation.status === this.consultationStatus.absenceDoctor
            },

            /**
             * キャンセル事由の虫眼鏡アイコン押下時
             * @param {object} consultation
             */
            onClickCancelReason: function (consultation) {
                bus.$emit('open-modal-consultation-cancel-info-modal', consultation)
            },
        },

        computed: {
            /**
             * 検索用ステータスリストを返す
             *
             * @return {object}
             */
            consultationSearchStatuses: function () {
                const statuses = this.consultationStatus.all

                statuses.splice(3, 0, { value: 'cancel-all', text: 'キャンセル' })
                statuses.splice(8, 0, { value: 'absence-all', text: '未入室終了' })
                statuses.push({ value: 'finish-no-report', text: `${this.$locale.consultation_host}終了（未）` })
                statuses.push({ value: 'finish-report', text: `${this.$locale.consultation_host}終了（記）` })

                return statuses
            },

            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if ( this.paginationConf.totalRows < 1 ) {
                    return '';
                }

                return `全${this.paginationConf.totalRows}件中 ${this.paginationConf.from}～${this.paginationConf.to}件表示`;
            },
        },
    };
</script>

<style scoped lang="scss">
.reservedLabel {
    position: relative;
    top: -1px;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    background-color: #e7a222;
    border-radius: 50%;

    &.reservedLabelDraftCancel {
        background-color: #7e7e7e;
    }
    &.reservedLabelDraftDoctor {
        background-color: #228ee7;
    }
}

.doctorMenuHealthPackageIcon {
    margin: 3px 0 1px;

    img {
        width: 130px;
    }
}

.reservedNotice {
    display: flex;
    align-items: center;

    div:nth-child(1) {
        width: 16px;
        height: 12px;
        background: #244787;
        border-radius: 4px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }

    &.reservedNoticeMatching {
        div:nth-child(1) {
            background: #D95672;
        }
    }
}

.reservedByDoctor {
    display: inline-block;
    padding: 0 4px;
    color: #fff;
    background: #244787;
    border-radius: 4px;
}

.reservedByMatching {
    display: inline-block;
    padding: 0 4px;
    color: #fff;
    background: #D95672;
    border-radius: 4px;
}

.status-reserved {
    display: flex;
    align-items: center;
    margin: 0 0 5px 10px;

    div:nth-child(1) {
        width: 10px;
        height: 10px;
        background: #417daf;
        border-radius: 5px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }
}
.status-hold {
    display: flex;
    align-items: center;
    margin: 0 0 5px 10px;

    div:nth-child(1) {
        width: 10px;
        height: 10px;
        background: #2fa69a;
        border-radius: 5px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }
}
.status-no-report {
    display: flex;
    align-items: center;
    margin: 0 0 5px 10px;

    div:nth-child(1) {
        width: 10px;
        height: 10px;
        background: #efc72f;
        border-radius: 5px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }
}
.status-reported {
    display: flex;
    align-items: center;
    margin: 0 0 5px 10px;

    div:nth-child(1) {
        width: 10px;
        height: 10px;
        background: #98a6ad;
        border-radius: 5px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }
}
.status-canceled {
    display: flex;
    align-items: center;
    margin: 0 0 5px 10px;

    div:nth-child(1) {
        width: 10px;
        height: 10px;
        background: #ef7320;
        border-radius: 5px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }
}

.matchingBtn {
    margin-top: 3px;
    padding: 2px 6px;
    font-size: 11px;
}

.cancelReasonWrapper {
    color: #424242;
    background: #FFF0E6;
    border-radius: 4px;

    .cancelReasonHeading {
        padding: 4px 8px;
        font-size: 11px;
        font-weight: bold;
        background: #F9D2B8;
        border-radius: 4px 4px 0 0;
    }

    .cancelReasonContent {
        padding: 4px 8px;
        font-size: 10px;

        .cancelReasonDatetime {
            img {
                cursor: pointer;
            }
        }
    }

    &.cancelReasonWrapperAbsence {
        background: #F3EEFE;

        .cancelReasonHeading {
            background: #D7C5FC;
        }
    }
}
</style>
